/* @flow */

import React from 'react';

import { translate } from '../../../base/i18n';
import {
    IconMicSlash,
    IconMic
} from '../../../base/icons';
import { PARTICIPANT_ROLE } from '../../../base/participants';
import { connect } from '../../../base/redux';
import AudioMuteButton from '../../../toolbox/components/AudioMuteButton';
import { ToolbarButton } from '../../../toolbox/components/web';
import AbstractMuteButton, {
    _mapStateToProps,
    type Props
} from '../../../video-menu/components/AbstractMuteButton';

/**
 * Implements a React {@link Component} which displays a button for audio muting
 * a participant in the conference.
 *
 * NOTE: At the time of writing this is a button that doesn't use the
 * {@code AbstractButton} base component, but is inherited from the same
 * super class ({@code AbstractMuteButton} that extends {@code AbstractButton})
 * for the sake of code sharing between web and mobile. Once web uses the
 * {@code AbstractButton} base component, this can be fully removed.
 */
class MuteAudioButton extends AbstractMuteButton {
    /**
     * Instantiates a new {@code Component}.
     *
     * @inheritdoc
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            jigasiMuted: false
        };
        this._handleClick = this._handleClick.bind(this);
        this._handleUnmuteClick = this._handleUnmuteClick.bind(this);
        this.handleJigasiClick = this.handleJigasiClick.bind(this);
    }

    handleJigasiClick() {
        const { jigasiMuted } = this.state
        if(!jigasiMuted) {
            this._handleClick()
            this.setState({ jigasiMuted: true })
            return
        }
        this._handleUnmuteClick()
        this.setState({ jigasiMuted: false })
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _audioTrackMuted, t, isLocal, _localParticipant, isJigasi, participant, tracks } = this.props;
        const { jigasiMuted } = this.state;
        // let disabled = false;
        const track = tracks.find(tr => tr.participantId === participant?.id);

/*          console.log("xxx participant in button: ", participant);
        console.log("xxx _audioTrackMuted in button: ", _audioTrackMuted);
        console.log("xxx isLocal in button: ", isLocal);
        console.log("xxx _localParticipant in button: ", _localParticipant);
        console.log("xxx isJigasi in button: ", isJigasi);
        console.log("xxx _localParticipant.role in button: ", _localParticipant.role);
        console.log("xxx PARTICIPANT_ROLE.MODERATOR in button: ", PARTICIPANT_ROLE.MODERATOR);
        console.log("xxx _localParticipant.id in button: ", _localParticipant.id);
        console.log("xxx participant?.id in button: ", participant?.id);
        console.log("xxx track in button: ", track);
        console.log("xxx tracks in button: ", tracks);
        console.log("xxx participant?.enable in button: ", participant?.enable);
        console.log("xxx track?.muted in button: ", track?.muted); */


        let disabled = false; // TEMPORARILY TURN ON FOR JIGASI // isJigasi ? true : false;

        if (_localParticipant.role !== PARTICIPANT_ROLE.MODERATOR && _localParticipant.id !== participant?.id) {
            disabled = true;
        }

        let isModerator = false;
        
        if ( _localParticipant.role === PARTICIPANT_ROLE.MODERATOR ) isModerator = true;

/*
        if (_localParticipant.role === PARTICIPANT_ROLE.MODERATOR && _localParticipant.id !== participant?.id) {
            participant?.enable ? disabled = true : disabled = false;
        }

         if (_localParticipant.id === participant?.id && (!participant?.enable || participant?.enable !== 'undefined')  && track?.muted) {
            disabled = true;
        } */

        if (!track) {
            disabled = true;
        }
        // console.log("xxx disabled in button: ", disabled);
        // console.log("xxx isLocal in button: ", isLocal);
        return (
/*             <AudioMuteButton
                    customClass = { 'toolbox-audio-toggle' }
                    disabled = { disabled } /> */
             isLocal
                ? <AudioMuteButton
                    customClass = { 'toolbox-audio-toggle' }
                    disabled = { disabled } />
                :
                 (<>

                     { isJigasi && isModerator ?
                         <ToolbarButton
                             accessibilityLabel={jigasiMuted ? t('toolbar.accessibilityLabel.unmute') : t('toolbar.accessibilityLabel.mute') }
                             className={'button_recordding'}
                             icon={jigasiMuted ? IconMicSlash: IconMic}
                             key='unmute'
                             onClick={this.handleJigasiClick}
                             tooltip={jigasiMuted ? t('thumbnail.unmute') : t('thumbnail.mute')}
                         />
                         :
                         <ToolbarButton
                             accessibilityLabel={t('toolbar.accessibilityLabel.mute')}
                             disabled={disabled}
                             className={'button_recordding'}
                             icon={_audioTrackMuted ? IconMicSlash : IconMic}
                             key='mute'
                             onClick={disabled ? undefined : this._handleClick}
                             tooltip={t('thumbnail.mute')}
                         />
                     }
                 </>)

/*                     : <ToolbarButton
                    accessibilityLabel = { t('toolbar.accessibilityLabel.hangup') }
                    disabled = { disabled }
                    className = { 'button_recordding background-hangup' }
                    icon = { IconHangup }
                    key = 'hangup'
                    onClick = { disabled ? undefined : this._handleClick }
                    tooltip = { t('thumbnail.hangup') } /> */

/*                 : <ToolbarButton
                    accessibilityLabel = { t('toolbar.accessibilityLabel.audio') }
                    icon = { _audioTrackMuted ? IconMicDisabled : IconMicrophone }
                    key = 'mute'
                    disabled = { disabled }
                    onClick = { this._handleClick }
                    className = 'button_recordding'
                    tooltip = { t('thumbnail.mute') } />  */


        // <VideoMenuButton
        //     buttonText = { t(muteConfig.translationKey) }
        //     displayClass = { muteConfig.muteClassName }
        //     icon = { IconMicDisabled }
        //     id = { `mutelink_${participantID}` }
        //     // eslint-disable-next-line react/jsx-handler-names
        //     onClick = { this._handleClick } />
        );
    }

    _handleClick: () => void;
    _handleUnmuteClick: () => void;
}

export default translate(connect(_mapStateToProps)(MuteAudioButton));
